import React, { useState, useEffect } from "react";
import "./Footer.scss";
import apiClient from "../../api/apiClient";
import apiEndpoints from "../../api/apiEndpoints";

interface Promotion {
  icon?: string;
  title: string;
  tag_line: string;
  brief: string;
  footer: string;
  navigationUrl?: string;
}

type ApiResponse = Promotion[];

interface FooterProps {
  clientId: string | number;
  copyrightText: string;
}

const Footer: React.FC<FooterProps> = ({ clientId, copyrightText }) => {
  const [promotions, setPromotions] = useState<Promotion[]>([]);

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await apiClient.get<ApiResponse>(
          apiEndpoints.getPromotions(),
          {
            params: { clientId },
          }
        );
        if (response && response.data) {
          setPromotions(response.data);
        }
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
    };

    fetchPromotions();
  }, [clientId]);

  const handlePromotionClick = (url?: string) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <footer className="footer-container d-flex flex-column mt-5">
      {promotions.length > 0 && (
        <ul
          id="promotions-list-container"
          className="list-unstyled justify-content-center m-auto row mt-4 mb-4 w-75">
          {promotions.map((promotion, index) => (
            <li
              key={index}
              className="col-md-4 col-12 mb-4 mr-md-4 promotions-list"
              onClick={() => handlePromotionClick(promotion.navigationUrl)}>
              <div className="promotions-card card h-100">
                <div className="w-100 bg-transparent border-0 p-0 card-header d-flex promotions-header">
                  <div className="common-sized-icon-big vertical-center h-100">
                    <img
                      src="/assets/images/icons/promotions.png"
                      className="img-fluid"
                      alt="promotions icon"
                    />
                  </div>
                  <p className="common-weight-600 common-size-14 vertical-center color-white m-0">
                    {promotion.title}
                  </p>
                </div>
                <div className="card-body pb-0 text-start">
                  <span className="common-size-14 common-weight-600">
                    {promotion.tag_line}
                  </span>
                  <p
                    className="common-size-14 mt-2"
                    dangerouslySetInnerHTML={{ __html: promotion.brief }}></p>
                </div>
                <div className="card-footer bg-transparent w-100 border-0">
                  <span
                    className="common-size-14"
                    dangerouslySetInnerHTML={{
                      __html: promotion.footer,
                    }}></span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
      <div className="w-100">
        <div className="w-100 d-flex flex-column-mobile justify-content-between align-items-center pt-3 common-padding-content">
          <div className="footer-policy-section col-md-3 col-12">
            <a
              target="_blank"
              href="https://voidsolutions.in/policies.html"
              className="no-underline policy-anchor">
              Our Policies
            </a>
          </div>
          <div className="d-flex col-md-9 col-12 footer-social-icons align-items-center justify-content-end">
            <p>{copyrightText}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
